@if (notificationService.notification()) {
<app-notification-item
  [notification]="notificationService.notification()!"
  [@slideInOut]>
</app-notification-item>
}
